import { Attributes, DateUtils, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';

export default class FlexiDivAnnexureCriteria extends Model.CriteriaBase {
    static typeName = "FlexiDivAnnexureCriteria";

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = DateUtils.monthStart(DateUtils.today());

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = DateUtils.monthEnd(DateUtils.today());

    @Rules.Required()
    public investorReferralTypeId: number | null = null;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<FlexiDivAnnexureCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Flexi Div Annexure Criteria";
    }
}